module.exports = __webpack_public_path__ + "static/media/steps_on_the_way_cover.aa7f5cd7.jpg";